export default "__VITE_ASSET__CNp$k_Qa__"